(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["react-minimal-datetime-range"] = factory(require("React"), require("ReactDOM"));
	else
		root["react-minimal-datetime-range"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__883__, __WEBPACK_EXTERNAL_MODULE__845__) {
return 